"use client";

import React from "react";

/**
 * Slim top-of-page progress bar — replaces the old full-screen dark overlay.
 * Renders a 2 px track at the top of the viewport with an animated shimmer bar.
 * Non-blocking: nothing is covered or dimmed.
 */
const Loader = () => {
  return (
    <>
      <style>{`
        @keyframes loader-sweep {
          0%   { transform: translateX(-100%); }
          100% { transform: translateX(450%); }
        }
        .loader-sweep-bar {
          animation: loader-sweep 1.4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
      `}</style>

      {/* Track */}
      <div className="fixed top-0 left-0 right-0 z-[9999] h-[2px] overflow-hidden bg-[#099ed1]/15">
        {/* Moving shimmer */}
        <div
          className="loader-sweep-bar absolute inset-y-0 w-[30%] bg-gradient-to-r from-transparent via-[#099ed1] to-transparent"
        />
      </div>
    </>
  );
};

export default Loader;
